import Homepage from "../pages/Homepage";
import CommonPage from "../pages/CommonPage";

export interface IRoutes {
  name: string;
  path: string;
  exact: boolean;
  component: React.FunctionComponent;
}
// 路由配置
export const routes: IRoutes[] = [
  {
    name: "homepage",
    path: "/",
    exact: true,
    component: Homepage,
  },
  {
    name: "bindQQmail",
    path: "/bindQQmail",
    exact: true,
    component: CommonPage,
  },
  {
    name: "bindOutlookMail",
    path: "/bindOutlookMail",
    exact: true,
    component: CommonPage,
  },
  {
    name: "bindEnterpriseMail",
    path: "/bindEnterpriseMail",
    exact: true,
    component: CommonPage,
  },
  {
    name: "importICSFile",
    path: "/importICSFile",
    exact: true,
    component: CommonPage,
  },
  {
    name: "importFlybookSchedule",
    path: "/importFlybookSchedule",
    exact: true,
    component: CommonPage,
  },
  {
    name: "importICloud",
    path: "/importICloud",
    exact: true,
    component: CommonPage,
  },
  {
    name: "subscribeICloud",
    path: "/subscribeICloud",
    exact: true,
    component: CommonPage,
  },
  {
    name: "subscribeOutlook",
    path: "/subscribeOutlook",
    exact: true,
    component: CommonPage,
  },
  {
    name: "subscribeGoogle",
    path: "/subscribeGoogle",
    exact: true,
    component: CommonPage,
  },
];
// 帮助页面首页配置
export const linkConfig = [
  {
    title: "从邮箱账号中导入",
    lists: [
      {
        desc: "如何从QQ邮箱中导入日程？",
        path: "/bindQQmail",
      },
      {
        desc: "如何从Outlook邮箱中导入日程？",
        path: "/bindOutlookMail",
      },
      {
        desc: "如何从企业邮箱中导入日程？",
        path: "/bindEnterpriseMail",
      },
    ],
  },
  {
    title: "从本地日历文件导入",
    lists: [
      {
        desc: "如何导入ICS文件？",
        path: "/importICSFile",
      },
    ],
  },
  {
    title: "从CalDav账号导入",
    lists: [
      {
        desc: "如何通过CalDav账号导入飞书日程？",
        path: "/importFlybookSchedule",
      },
      {
        desc: "如何通过CalDav账号导入iCloud日程？",
        path: "/importICloud",
      },
    ],
  },
  {
    title: "从URL中导入",
    lists: [
      {
        desc: "如何订阅Google日历？",
        path: "/subscribeGoogle",
      },
      {
        desc: "如何订阅iCloud日历？",
        path: "/subscribeICloud",
      },
      {
        desc: "如何订阅Outlook日历？",
        path: "/subscribeOutlook",
      },
    ],
  },
];
